<template>
  <ModuleWrapper :moduleId="moduleId" title="Enter Event Experience" @initializeData="initializeData">
    <template #main>
      <StudioToggleWithLabel
        id="enter-event-button-toggle"
        label="Enter Event Button"
        subLabel="This setting cannot be changed less than one hour before the start of the event. Hide the button that allows users to enter the event from the event landing page. 60 minutes before the event starts the button will automatically be enabled and allow attendees to enter."
        class="tw-mb-7"
        :checked="enterEventButtonEnabled"
        :title="
          isEnterEventButtonToggleDisabled
            ? 'This setting cannot be changed less than one hour before the start of the event'
            : ''
        "
        :disabled="isEnterEventButtonToggleDisabled"
        @update:checked="handleEnterEventButtonToggle"
      />
      <StudioToggleWithLabel
        id="attendee-tech-check-toggle"
        label="Attendee Tech Check"
        subLabel="Require attendees to test their network strength and audio before entering the event."
        class="tw-mb-7"
        :checked="attendeeTechCheckEnabled"
        @update:checked="handleAttendeeTechCheckToggle"
      />
      <StudioToggleWithLabel
        id="show-onboarding-toggle"
        label="Mandatory Attendee Profiles"
        subLabel="Require attendees to create a profile when entering the event for the first time."
        :checked="showOnboarding"
        @update:checked="handleShowOnboardingToggle"
      />
    </template>
  </ModuleWrapper>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapActions, mapGetters, mapMutations } from 'vuex';

import ModuleWrapper from './ModuleWrapper.vue';

import { StudioToggleWithLabel } from '@/studioComponents';
import isEventAboutToStart from '@/utils/isEventAboutToStart';

export default defineComponent({
  name: 'EnterEventExperience',
  components: {
    ModuleWrapper,
    StudioToggleWithLabel
  },

  props: {
    moduleId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      enterEventButtonEnabled: false,
      attendeeTechCheckEnabled: false,
      showOnboarding: false
    };
  },
  mounted() {
    this.initializeData();
  },
  computed: {
    ...mapGetters('branding', {
      getInitialModuleData: 'getInitialModuleData'
    }),
    ...mapGetters('studioEventList', {
      event: 'getCurrentEvent'
    }),
    isEnterEventButtonToggleDisabled(): boolean {
      if (!this.$route.params.eventId) {
        return false;
      }

      if (!this.event) {
        return true;
      }

      return isEventAboutToStart({
        startTime: this.event.start_time,
        timeInMinutes: 60
      });
    }
  },
  methods: {
    ...mapMutations('branding', {
      setChangesMadeInEvent: 'setChangesMadeInEvent'
    }),
    initializeData() {
      const moduleKeys = ['disable_enter_event_button', 'enable_tech_check', 'show_onboarding'];

      const { disable_enter_event_button, enable_tech_check, show_onboarding } = this.getInitialModuleData(moduleKeys);

      this.enterEventButtonEnabled = !disable_enter_event_button;
      this.attendeeTechCheckEnabled = enable_tech_check;
      this.showOnboarding = show_onboarding;
    },
    handleEnterEventButtonToggle(e) {
      this.enterEventButtonEnabled = e.target.checked;
      this.setChangesMadeInEvent({
        disable_enter_event_button: !this.enterEventButtonEnabled
      });
    },
    handleAttendeeTechCheckToggle(e) {
      this.attendeeTechCheckEnabled = e.target.checked;
      this.setChangesMadeInEvent({
        enable_tech_check: this.attendeeTechCheckEnabled
      });
    },
    handleShowOnboardingToggle(e) {
      this.showOnboarding = e.target.checked;
      this.setChangesMadeInEvent({
        show_onboarding: this.showOnboarding
      });
    }
  }
});
</script>
